import React from "react";
import { Check } from "lucide-react";

export default function TrustBar() {
  const buildingItems = [
    "Multi-cloud platforms",
    "Kubernetes at scale",
    "AI-driven infrastructure"
  ];

  return (
    <section className="nst-light border-y border-[#D9E0F0] py-12">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-[#0A1F47]">
            Trusted by teams building:
          </h2>
        </div>
        <div className="flex flex-col md:flex-row items-center justify-center gap-6 md:gap-12">
          {buildingItems.map((item) => (
            <div key={item} className="flex items-center gap-3">
              <span className="flex items-center justify-center w-6 h-6 rounded-full bg-[#2E6BF6]">
                <Check className="w-4 h-4 text-white" />
              </span>
              <p className="text-base md:text-lg font-semibold text-[#0A1F47]">
                {item}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

